import { render } from "./OtherNavigation.vue?vue&type=template&id=1fa03e3b"
import script from "./OtherNavigation.vue?vue&type=script&lang=ts"
export * from "./OtherNavigation.vue?vue&type=script&lang=ts"
script.render = render

export default script